import { connectColors } from '@/theme/colors';
import { Button, Modal } from '@lego/connect-components-react';
import { Flex, Text, VerticalStack } from '@lego/klik-ui';
import { StatusCircleExclamation } from '@lego/klik-ui-icons';
import type { RefObject } from 'react';

type ResetNoveltyPricesConfirmModalProps = {
  isOpen: boolean;
  triggerRef: RefObject<HTMLButtonElement | null>;
  priceUnitName: string;
  isDeleting: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

const ResetNoveltyPricesConfirmModal = ({
  isOpen,
  triggerRef,
  priceUnitName,
  isDeleting,
  onConfirm,
  onClose,
}: ResetNoveltyPricesConfirmModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="small"
      triggerRef={triggerRef}
    >
      <Modal.Title>Reset Novelty Prices</Modal.Title>
      <Modal.Content>
        <Flex gap="8px">
          <StatusCircleExclamation
            color={connectColors.core.red[900]}
            width="24px"
            height="24px"
          />
          <VerticalStack alignItems="start" gap="4px">
            <Text>
              You are about to delete all novelty prices for{' '}
              <b>{priceUnitName}</b>.
            </Text>
            <Text>This action cannot be undone. Do you want to continue?</Text>
          </VerticalStack>
        </Flex>
      </Modal.Content>
      <Modal.Footer>
        <Button
          aria-label="No"
          disabled={isDeleting}
          appearance="ghost"
          variant="neutral"
          onClick={onClose}
        >
          No
        </Button>
        <Button
          aria-label="Yes"
          disabled={isDeleting}
          loading={isDeleting}
          variant="negative"
          onClick={onConfirm}
        >
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ResetNoveltyPricesConfirmModal;
